import React, { useState } from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon, CheckCircleIcon } from 'lucide-react';
const packs = [{
  id: 'avanzado',
  icon: '📗',
  label: 'MÁS ELEGIDO',
  labelColor: 'bg-brand-orange',
  title: 'PACK AVANZADO',
  subtitle: 'CICLO SUPERIOR — El más completo',
  details: ['Todo el Ciclo Básico + Ciclo Superior + Drive', 'Tomos 1 a 6 (1° a 6° año completo)', 'Los 3 Bonos Estratégicos', 'Actualizaciones de por vida'],
  originalPrice: '$39.900',
  price: '$19.990',
  href: 'https://checkout.guiadigital360.online/cart/44131411918917:1',
  borderSelected: 'border-brand-orange',
  ringSelected: 'ring-brand-orange',
  priceColor: 'text-brand-orange'
}, {
  id: 'primaria',
  icon: '🎓',
  label: 'PRIMARIA',
  labelColor: 'bg-purple-600',
  title: 'PACK PRIMARIA',
  subtitle: 'Ciencias Naturales de 1° a 7° grado',
  details: ['📚 14 TOMOS COMPLETOS (840 páginas) — Teoría + Actividades para cada grado, de 1° a 7° año. Incluye contenidos alineados al Diseño Curricular de la Provincia de Buenos Aires con Metodología ABP integrada en cada tomo.', '🔬 35 EXPERIENCIAS CIENTÍFICAS REALES — 7 experiencias por grado con bitácoras de registro, hipótesis, tablas de datos y conclusiones. Listas para realizar en el aula sin equipamiento especializado.', '🏆 7 PRODUCTOS FINALES ABP + 14 DIPLOMAS — Cada grado culmina con un producto final presentable ante la comunidad escolar: ferias, murales, atlas, prototipos, observatorios y un Congreso Científico. Diploma oficial de cierre por tomo.'],
  price: '$14.990',
  href: 'https://checkout.guiadigital360.online/cart/44812990218309:1',
  borderSelected: 'border-purple-600',
  ringSelected: 'ring-purple-600',
  priceColor: 'text-purple-600'
}, {
  id: 'vip',
  icon: '🚀',
  label: 'UPSELL EXCLUSIVO',
  labelColor: 'bg-brand-blue',
  title: 'COMBO GESTIÓN TOTAL VIP',
  subtitle: 'Contiene lo del Pack Avanzado + Gestión Total VIP',
  details: ['12 Exámenes Trimestrales con clave de respuestas', '150 Frases profesionales para boletines', '6 TP Integradores para diciembre y febrero'],
  savings: 'Ahorrás $12.000 comprando todo junto',
  price: '$24.990',
  href: 'https://checkout.guiadigital360.online/cart/44777826648133:1',
  borderSelected: 'border-brand-blue',
  ringSelected: 'ring-brand-blue',
  priceColor: 'text-brand-blue'
}];
export function PricingSection() {
  const [selected, setSelected] = useState<string>('avanzado');
  const selectedPack = packs.find(p => p.id === selected)!;
  const getButtonText = () => {
    if (selected === 'avanzado') return '→ QUIERO MI PACK AVANZADO';
    if (selected === 'primaria') return '→ QUIERO MI PACK PRIMARIA';
    return '→ SÍ, QUIERO EL COMBO VIP';
  };
  const getButtonClass = () => {
    if (selected === 'vip') {
      return 'bg-brand-blue hover:bg-blue-700 shadow-[0_8px_25px_-5px_rgba(0,87,217,0.5)] hover:shadow-[0_12px_30px_-5px_rgba(0,87,217,0.7)]';
    }
    if (selected === 'primaria') {
      return 'bg-purple-600 hover:bg-purple-700 shadow-[0_8px_25px_-5px_rgba(147,51,234,0.5)] hover:shadow-[0_12px_30px_-5px_rgba(147,51,234,0.7)]';
    }
    return '';
  };
  return <section id="compra" className="py-14 md:py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-209">
      <div className="max-w-2xl mx-auto" data-id="element-210">
        <div className="text-center mb-6 md:mb-10" data-id="element-211">
          <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-3" data-id="element-212">
            Elegí tu MegaPack:
          </h2>
          <p className="text-xl md:text-2xl font-bold text-brand-blue" data-id="element-213">
            Precios de Lanzamiento
          </p>
        </div>

        {/* Selectable Cards */}
        <div className="space-y-4 mb-8" data-id="element-214">
          {packs.map(pack => {
          const isSelected = selected === pack.id;
          return <button key={pack.id} onClick={() => setSelected(pack.id)} className={`w-full text-left rounded-2xl p-4 md:p-6 transition-all duration-200 relative
                  ${isSelected ? `bg-white shadow-xl border-3 ${pack.borderSelected} ring-2 ${pack.ringSelected}` : 'bg-white/70 shadow-sm border-2 border-gray-200 opacity-75 hover:opacity-100 hover:shadow-md'}`} data-id="element-215">
                {/* Badge */}
                {pack.label && <div className={`absolute -top-3 left-4 ${pack.labelColor} text-white font-black px-3 py-0.5 rounded-full text-[10px] md:text-xs tracking-wider shadow-md`} data-id="element-216">
                    ⭐ {pack.label}
                  </div>}

                <div className="flex items-start gap-3 md:gap-4" data-id="element-217">
                  {/* Radio indicator */}
                  <div className="mt-1 flex-shrink-0" data-id="element-218">
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? pack.id === 'avanzado' ? 'border-brand-orange bg-brand-orange' : pack.id === 'primaria' ? 'border-purple-600 bg-purple-600' : 'border-brand-blue bg-brand-blue' : 'border-gray-300 bg-white'}`} data-id="element-219">
                      {isSelected && <CheckCircleIcon className="w-5 h-5 text-white" data-id="element-220" />}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0" data-id="element-221">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-1 md:gap-4 mb-2" data-id="element-222">
                      <h3 className="text-lg md:text-xl font-black text-brand-dark flex items-center gap-2" data-id="element-223">
                        <span data-id="element-224">{pack.icon}</span> {pack.title}
                      </h3>
                      <div className="flex items-center gap-2" data-id="element-225">
                        {pack.originalPrice && <span className="text-gray-400 text-sm line-through font-bold" data-id="element-226">
                            {pack.originalPrice}
                          </span>}
                        <span className={`text-2xl md:text-3xl font-black ${pack.priceColor}`} data-id="element-227">
                          {pack.price}
                        </span>
                        <span className="text-xs text-gray-500 font-medium" data-id="element-228">
                          ARS
                        </span>
                      </div>
                    </div>

                    <p className="text-sm text-gray-600 font-medium mb-2" data-id="element-229">
                      {pack.subtitle}
                    </p>

                    {isSelected && <div className="mt-3 space-y-2" data-id="element-230">
                        {pack.details.map((d, i) => <p key={i} className="text-xs md:text-sm text-gray-700 flex items-start gap-2 leading-relaxed" data-id="element-231">
                            <span className="text-brand-green flex-shrink-0 mt-0.5" data-id="element-232">
                              ✅
                            </span>{' '}
                            <span data-id="element-233">{d}</span>
                          </p>)}
                        {pack.savings && <div className="bg-green-100 text-green-800 font-bold text-center py-1.5 rounded-lg text-sm mt-3" data-id="element-234">
                            {pack.savings}
                          </div>}
                      </div>}
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Single CTA Button */}
        <div className="mb-8" data-id="element-235">
          <CTAButton text={getButtonText()} href={selectedPack.href} isLink={true} className={getButtonClass()} data-id="element-236" />
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-xs md:text-sm text-gray-600 font-bold bg-white py-4 px-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-237">
          <span className="flex items-center gap-1.5" data-id="element-238">
            <LockIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-500" data-id="element-239" /> Pago
            seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-240">
            <ZapIcon className="w-4 h-4 md:w-5 md:h-5 text-yellow-500" data-id="element-241" /> Acceso
            en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-242">
            <ShieldCheckIcon className="w-4 h-4 md:w-5 md:h-5 text-brand-green" data-id="element-243" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-244">
            <CreditCardIcon className="w-4 h-4 md:w-5 md:h-5 text-blue-500" data-id="element-245" />{' '}
            Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}